/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lesson-container[_ngcontent-%COMP%]{height:calc(100vh - 100px)}.lesson-container[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{border:none}.skip-quiz-finalize-error[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;gap:1rem;padding:.75rem 1rem;background:#fee;color:#f41d1d}.skip-quiz-finalize-error[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;border:none;color:#0080ff;font-weight:700;text-decoration:underline;cursor:pointer}  .tablist-container .nav-item{margin-top:1px;margin-bottom:0}  .tab-content .container{margin-top:2rem}"];
export { styles as styles };
//# sourceMappingURL=lesson-page.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/learning/lesson-page/lesson-page.component.scss.shim.ngstyle.js
// module id = 1720
// module chunks = 27 28 29